module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.required(_vm.validate)) ? _c('span', {
    staticClass: "form__validation"
  }, [_vm._v("\n      " + _vm._s(_vm.L.localize('Validation_Required')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.checkSameAs(_vm.validate)) ? _c('span', {
    staticClass: "form__validation"
  }, [_vm._v("\n      " + _vm._s(_vm.L.localize('Validation_Compare')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.validation[_vm.model]) ? _vm._l((_vm.validation[_vm.model].messages), function(error) {
    return _c('span', {
      staticClass: "form__validation"
    }, [_vm._v(_vm._s(error))])
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c063eeb6!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/helpers/Validation.vue
// module id = 758
// module chunks = 1